export enum ProductType {
  Food = 'food',
  Market = 'market',
  Shop = 'shop',
  Service = 'service',
}
